"use client";

import { useEffect, useRef } from "react";
import { markGoalCompletedTx } from "@/lib/db/goals";
import { isIndividualMoneyGoal, type Goal } from "@/lib/schemas";

/**
 * Auto-mark dla individual_money: gdy `balanceMinor >= targetMinor` i
 * `goal.completedAt` jeszcze undefined, zapisuje `completedAt = serverTimestamp()`.
 * Idempotent przez transakcyjny guard `markGoalCompletedTx`.
 *
 * Family goals (family_count, family_offline_count) mają własny auto-mark
 * w `useGoalProgress` — tam progress wyliczany z listenera completion'ów.
 */
export function useAutoMarkGoalCompletion(
  hid: string | undefined,
  goals: Goal[],
  balanceMinor: number,
): void {
  const triggeredRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (!hid) return;
    for (const g of goals) {
      if (!isIndividualMoneyGoal(g)) continue;
      if (g.completedAt) continue;
      if (balanceMinor < g.targetMinor) continue;
      if (triggeredRef.current.has(g.id)) continue;
      triggeredRef.current.add(g.id);
      void markGoalCompletedTx(hid, g.id).catch(() => {
        triggeredRef.current.delete(g.id);
      });
    }
  }, [hid, goals, balanceMinor]);
}
